angular.module('aq.reports')
    .filter('orDash', function() {
        return function(value) {
            if (_.isUndefined(value) || _.isNull(value)) return "-"
            return value;
        }
    });